import ToolbarEditor from 'components/ToolbarEditor';
import { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import lizzyApi from 'lizzyApiAdapter';
import { setIsDisplayed as setIsToolbarDisplayed, setCurrentBounds } from 'redux/toolbar';
import IconButton from 'components/IconButton';

const ToolbarTest = () => {
  const [isDisplayed, setIsDisplayed] = useState(false);
  const [showControls, setShowControls] = useState(false);
  const [customPosition, setCustomPosition] = useState({ x: '', y: '' });
  const wrapperRef = useRef({ clientWidth: 0 });
  const toolbarRef = useRef();

  const dispatch = useDispatch();

  useEffect(() => {
    if (wrapperRef.current) {
      lizzyApi.assignCallbacks({
        openLizzyPopup: ({ position }) => {
          setIsDisplayed(true);
          dispatch(setIsToolbarDisplayed(true));
          dispatch(setCurrentBounds({
            left: position.x,
            bottom: position.y
          }));
        },
        onCloseLizzyPopup: () => {
          setIsDisplayed(false);
          dispatch(setIsToolbarDisplayed(false));
        }
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wrapperRef.current]);

  const handleCustomPositionChange = (event) => {
    setIsDisplayed(false);

    setCustomPosition({
      ...customPosition,
      [event.target.name]: event.target.value
    });

    dispatch(setCurrentBounds({
      left: customPosition.x,
      bottom: customPosition.y
    }));

    setIsDisplayed(true);
  };

  return (
    <Wrapper>
      <Container ref={wrapperRef}>
        {isDisplayed && (
          <ToolbarEditor
            ref={toolbarRef}
            selectedText=''
            editorContainerEl={wrapperRef.current}
          />
        )}
      </Container>

      <Controls>
        {showControls ? (
          <IconButton iconSource='feather' icon='x' onClick={() => setShowControls(false)} />
        ) : (
          <IconButton iconSource='feather' icon='menu' onClick={() => setShowControls(true)} />
        )}
        {showControls && (
          <form>
            <label>
              x:
              <input
                type='number'
                name='x'
                value={customPosition.x}
                onChange={handleCustomPositionChange}
              />
            </label>
            <label>
              y:
              <input
                type='number'
                name='y'
                value={customPosition.y}
                onChange={handleCustomPositionChange}
              />
            </label>
          </form>
        )}
      </Controls>
    </Wrapper>
  );
}

export default ToolbarTest;

const Wrapper = styled.div`
  position: relative;
  padding: 20px;
  height: 100vh;
`;

const Container = styled.div`
  position: relative;
  width: calc(100% - 20px);
  height: 100%;
`;

const Controls = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  padding-left: 40px;

  label {
    display: block;
  }

  input {
    width: 50px;
  }

  ${IconButton} {
    position: absolute;
    left: 0;
    top: 10px;
  }
`;